import { render, staticRenderFns } from "./NewPhoto.vue?vue&type=template&id=856d2d2a&"
import script from "./NewPhoto.vue?vue&type=script&lang=js&"
export * from "./NewPhoto.vue?vue&type=script&lang=js&"
import style0 from "./NewPhoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports